<template>
  <div class="bcw-card">
    <div v-if="task" class="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div class="bcw-info">
        <div class="bcw-name">{{ name }}</div>
        <span class="badge px-3 py-1 border-radius-sm" :class="statusClass">{{ $t(statusKey) }}</span>
        <span v-if="task.count_recipients" class="bcw-recipients">
          {{ $t('Assistant.Widget.Broadcast.Recipients', { count: task.count_recipients }) }}
        </span>
      </div>
      <router-link :to="editLink" class="btn btn-sm btn-outline-primary mb-0">
        {{ $t('Assistant.Widget.Broadcast.Edit') }}
      </router-link>
    </div>
    <div v-else class="bcw-empty">{{ $t('Assistant.Widget.Unsupported', { type: 'broadcast' }) }}</div>
  </div>
</template>

<script>
// Renders the broadcast object returned by create/save/activate/cancel/get_broadcast as a small
// card (name + status + link), reusing the same status labels/colors as the Broadcasting list
// page (Mailing.vue), so the chat and the dashboard never disagree on what a status means.
const STATUS_MAP = {
  0: { class: 'bg-gradient-secondary', key: 'Mailing.General.Statuses.Draft' },
  1: { class: 'bg-gradient-info', key: 'Mailing.General.Statuses.Not_started' },
  2: { class: 'bg-primary text-white', key: 'Mailing.General.Statuses.In_progress' },
  3: { class: 'bg-gradient-success', key: 'Mailing.General.Statuses.Done' },
  4: { class: 'bg-gradient-dark', key: 'Mailing.General.Statuses.Cancel' },
  5: { class: 'bg-gradient-danger', key: 'Mailing.General.Statuses.Error' },
  8: { class: 'bg-primary text-white', key: 'Mailing.General.Statuses.In_progress' },
}

export default {
  name: 'BroadcastCardWidget',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    task() {
      return this.data?.task ?? null
    },
    name() {
      return this.task?.name || this.$t('Assistant.Widget.Broadcast.Untitled')
    },
    statusEntry() {
      return STATUS_MAP[this.task?.status] || { class: 'bg-light text-dark', key: 'Mailing.General.Statuses.Draft' }
    },
    statusClass() {
      return this.statusEntry.class
    },
    statusKey() {
      return this.statusEntry.key
    },
    editLink() {
      return { name: 'EditCampaign', params: { id: this.task.id } }
    },
  },
}
</script>

<style scoped>
.bcw-card {
  width: 100%; padding: 12px 16px; border: 1px solid var(--ui-border); border-radius: var(--radius-lg);
  background: var(--ui-bg-card);
}
.bcw-info { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.bcw-name { font: 600 13px 'Open Sans', sans-serif; color: var(--ui-text-1); }
.bcw-recipients { font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3); }
.bcw-empty {
  display: flex; align-items: center; justify-content: center; min-height: 40px;
  font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3);
}
</style>
